import React from 'react'
import { CardHeader, CircularProgress, TextField, Typography, Box } from '@mui/material'
import { InputButton, Mensagens } from '../../Simple'
import { IoChevronBackOutline } from 'react-icons/io5'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { LoadingButton } from '@mui/lab'
import { FaAngleRight } from 'react-icons/fa'
import { ChatContext } from '../../../contexts/ChatContext'
import RouterHook from '../../../contexts/RouterHook'
import SendIcon from '@mui/icons-material/Send'
import moment from 'moment'
import { io } from 'socket.io-client'

import { stMob, stylesDesk } from './stylesChat'

export default function ChatSelMob() {
  const listRef = React.useRef(null)
  const serverRouter = RouterHook()
  const { userUCtx } = React.useContext(UsuarioContext)
  const { sttChatCtx, actionsChatCtx, loadsChat } = React.useContext(ChatContext)

  const [inputMsg, setInputMsg] = React.useState('')
  const [socket, setSocket] = React.useState(null)
  const [currentChatId, setCurrentChatId] = React.useState(null)

  React.useEffect(() => {
    const chatId = sttChatCtx.chat?.idchat
    if (listRef.current) {
      setTimeout(() => {
        listRef.current.scrollTop = listRef.current.scrollHeight
      }, 0)
    }
    if (chatId && chatId !== currentChatId) {
      if (socket) {
        socket.disconnect()
      }

      const newSocket = io(import.meta.env.VITE_URL_SOCKET + '/conectar-chat', {
        query: { idChat: chatId },
        transports: ['websocket'],
        withCredentials: true,
      })

      newSocket.on('connect', () => {
        setSocket(newSocket)
        setCurrentChatId(chatId)

        newSocket.emit('entrarChat', { idchat: chatId, gestor: false })

        // newSocket.on('message', mensagens => {})

        newSocket.on('novaMensagem', mensagem => {
          actionsChatCtx.atualizarMensagem(mensagem)

          actionsChatCtx.handleLoadChat('sendMsg', false)
        })
      })

      newSocket.on('disconnect', () => {})

      return () => {
        if (socket) {
          socket.emit('sairChat', { idchat: chatId, gestor: false })
          socket.disconnect()
        }
      }
    }
  }, [sttChatCtx.chat, currentChatId, socket])

  const handleSendMessage = () => {
    if (socket && inputMsg.trim()) {
      actionsChatCtx.handleLoadChat('sendMsg', true)
      socket.emit('enviarMensagem', {
        idchat: sttChatCtx.chat.idchat,
        modo_caixa_entrada: sttChatCtx.modeChat === 'agendamentos' ? 'modo_pedido' : 'modo_empresa',
        mensagem: {
          texto: inputMsg,
          enviadoPor: userUCtx.usuario.nome,
          criadaPorAdmin: false,
        },
      })
      setInputMsg('')
    }
  }

  return (
    <Box sx={stMob.containPageChatMob}>
      <CardHeader
        sx={{ ...stMob.containHeader, ...stMob.borderBottom }}
        avatar={
          <IoChevronBackOutline
            size={30}
            style={stMob.iconBack}
            onClick={() => {
              actionsChatCtx.handleChatStt('chat', null)
            }}
          />
        }
        title={
          <Typography variant='h6' sx={stMob.titlePage}>
            {`${moment(sttChatCtx.chat.pedido.dataInicio).format('hh:mm')} às ${moment(sttChatCtx.chat.pedido.dataFinal).format('hh:mm')}`}
          </Typography>
        }
        subheader={
          <Typography variant='body1' sx={stMob.subTitlePg}>
            {`${moment(sttChatCtx.chat.pedido.dataInicio).startOf('minute').fromNow().toLowerCase()}, em ${moment(
              sttChatCtx.chat.pedido.dataInicio,
            ).format('DD/MM/YY')}`}
          </Typography>
        }
      />
      <InputButton
        sx={stMob.buttonPedido}
        endIcon={<FaAngleRight size={20} />}
        onClick={() => {
          serverRouter('agendamento', sttChatCtx.chat.pedido.idpedido)
        }}
      >
        {sttChatCtx.chat.pedido.status} - Ver detalhes
      </InputButton>
      <Box sx={stylesDesk.containListMensagens} ref={listRef}>
        {sttChatCtx.chat.mensagens.map((msg, index) => (
          <Mensagens key={index} index={index} msg={msg} chat={sttChatCtx.chat} />
        ))}
      </Box>
      <Box sx={stylesDesk.containInputMensagens}>
        <TextField
          fullWidth
          hiddenLabel
          sx={stylesDesk.inputMsg}
          variant='filled'
          size='small'
          placeholder='Digite sua mensagem...'
          value={inputMsg}
          onChange={e => setInputMsg(e.target.value)}
        />
        <LoadingButton
          size='small'
          onClick={() => handleSendMessage()}
          endIcon={
            !loadsChat.sendMsg && <SendIcon sx={{ ...stylesDesk.iconSend, color: 'white' }} />
          }
          loading={loadsChat.sendMsg}
          loadingIndicator={<CircularProgress size={20} sx={stylesDesk.iconSend} />}
          variant='contained'
          sx={
            inputMsg.length
              ? stylesDesk.btnSendMsg
              : { ...stylesDesk.btnSendMsg, backgroundColor: '#d9d9d9' }
          }
        />
      </Box>
    </Box>
  )
}
